import { render, staticRenderFns } from "./getApp.vue?vue&type=template&id=585054d2&scoped=true&"
import script from "./getApp.vue?vue&type=script&lang=js&"
export * from "./getApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585054d2",
  null
  
)

export default component.exports